@layer design-system {
  .lineColorBlendMask {
    /* base mask styles applied via className */
  }

  .areaRectBackground {
    mix-blend-mode: color;
  }

  .edgeLine {
    stroke-width: 1;
    stroke-dasharray: 3 2;
  }

  .lineAxis {
    stroke-width: 1;
  }
}
